<template lang="pug">
.mt-4
  //- .notes.mb-4.d-flex.justify-end
    v-badge(bordered, overlap, color="error", :content="notes.length")
      v-btn(color="yellow", @click="notesOpened = true")
        v-icon(left) mdi-note
        | Notes
    Notes(
      :opened="notesOpened",
      :notes="notes",
      @close="(value) => (notesOpened = value)",
      @addNote="addNote"
    )

  v-tabs.mb-4
    v-tab(v-for="{ name, path } in reorganizedTabs", :key="path", :to="path") {{ name }}
  router-view
</template>

<script>
import Notes from "@/components/Expert/Notes/index";

let tabs = [
  "Overview",
  "Company Profile",
  "Case Profile",
  "Candidate",
  "Documents",
  "Online Application",
  "Cover Letter",
];

export default {
  name: "expert-case",

  components: {
    Notes,
  },

  data: () => ({
    tabs,
  }),

  computed: {
    reorganizedTabs() {
      return this.tabs.map((tab) => ({
        name: tab,
        path: tab.toLowerCase().split(" ").join("_"),
      }));
    },
  },
};
</script>
